<script setup lang="ts">
  import { computed } from 'vue'
  import { useModalStack } from '@gat-ship/vue-components'
  import TenantUserProvider from './TenantUserProvider.vue'
  import TenantUserDetailModal from '../modals/TenantUserDetailModal.vue'
  import {
    toValidTenantUserSection,
    type TenantUserDetailSection
  } from '../detail-modal/tenant-user-detail-modal-sections'

  // Open-state, the user id, and active section come from this modal's entry in
  // the central ordered stack (the `?modals=` codec owns the URL).
  const KIND = 'tenant-user'
  const stack = useModalStack()
  const entry = computed(() =>
    stack.entries.value.find((item) => item.kind === KIND)
  )

  function updateParams(patch: Record<string, string>): void {
    const current = entry.value
    if (!current) return
    stack.update(KIND, { ...current.params, ...patch })
  }

  const open = computed({
    get: () => entry.value != null,
    set: (value) => {
      if (!value) stack.close(KIND)
    }
  })
  const tenantUserId = computed(() => entry.value?.params.id)
  const activeSection = computed<TenantUserDetailSection>({
    get: () =>
      toValidTenantUserSection(entry.value?.params.tenantUserSection ?? null),
    set: (section) => updateParams({ tenantUserSection: section })
  })

  // Switch the modal to another user picked from the sidebar select.
  function handleSelect(userId: string) {
    updateParams({ id: userId })
  }
</script>

<template>
  <TenantUserProvider :tenant-user-id="tenantUserId">
    <TenantUserDetailModal
      v-model:open="open"
      v-model:section="activeSection"
      @select="handleSelect"
    />
  </TenantUserProvider>
</template>
